// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../panels/panel.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, ".gJ0cvZzsx{position:relative;display:flex;overflow:hidden;flex-direction:row;background-color:var(--gray-light3);transform:translateZ(0px)}._37FYn8SMx{box-sizing:border-box;padding-right:220px;flex:1 0 100%;overflow:auto}._1tWPhi65x{box-sizing:border-box;position:absolute;top:0;bottom:0;right:0;width:200px;border-left:1px solid rgba(0,0,0,0.1)}._1tWPhi65x>*{width:100%}._5iy2C4p9x{position:relative;margin:0 0 0 -20px}._2dUpdV4Ox{position:absolute;top:0;left:0;width:4px;height:24px;background-color:#006fc8;margin:3px 0;transition:transform 400ms cubic-bezier(0.215, 0.61, 0.355, 1)}@media screen and (-ms-high-contrast: active){._2dUpdV4Ox{background-color:highlight}}._7JgOEdhnx{padding:0px;margin:0px}._3H9U3bcCx{display:block;transition:color 100ms linear;text-decoration:none;color:var(--secondary-text);cursor:pointer}._1ASsz5AIx{color:var(--link-text)}@media screen and (-ms-high-contrast: active){._1ASsz5AIx{color:highlight}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"transitionDuration": "400ms",
	"tabHeight": "28px",
	"wrapper": "gJ0cvZzsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["scroll-container"] + "",
	"left": "_37FYn8SMx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["padding-m"] + "",
	"right": "_1tWPhi65x " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["flex"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["padding-m"] + "",
	"tabs": "_5iy2C4p9x",
	"marker": "_2dUpdV4Ox",
	"list": "_7JgOEdhnx",
	"tab": "_3H9U3bcCx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["padding-list-xs"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["paragraph-m"] + "",
	"active": "_1ASsz5AIx _3H9U3bcCx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["padding-list-xs"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["paragraph-m"] + " " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["bold"] + ""
};
module.exports = exports;
